import {
  INewTicketAutomationReceivedDaysAhead,
  ITicketAutomationReceivedDaysAhead,
} from "../models/ticket-automation-receive-days-ahead";
import { GlobalAxios } from "./../axios/axios-config";

const TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedDaysAhead/";

export const createTicketAutomationReceivedDaysAhead = (
  item: INewTicketAutomationReceivedDaysAhead
) => {
  return GlobalAxios.post(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE,
    item
  );
};

export const getTicketAutomationReceivedDaysAheadById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationReceivedDaysAhead>(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE + id
  );
};

export const updateTicketAutomationReceivedDaysAheadById = ({
  item,
  id,
}: {
  item: INewTicketAutomationReceivedDaysAhead;
  id: string;
}) => {
  return GlobalAxios.put(
    TICKET_AUTOMATION_RECEIVED_RULES_INSURANCE_CATEGORY_ROUTE + id,
    item
  );
};
